import React from "react";

export const NoMatchFound = () => {
  return <div className="NoMatchFound">No match found</div>;
};
